/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { deleteChoiceApi } from '../../api/choices/choicesApi';

export default function DeleteChoices({ value, setValue, callFunc }) {
  const deleteRow = async (id) => {
    try {
      const response = await deleteChoiceApi(id);
    } catch (e) {}
    callFunc();
    setValue({ isOpen: false });
    handleClose();
  };

  const handleClose = () => {
    callFunc();
    setValue({ isOpen: false });
  };

  return (
    <div>
      <Dialog
        open={value?.isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure to delete this row?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            cancel
          </Button>
          <Button onClick={() => deleteRow(value.id)}>Delete </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
